import script from "./PricingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PricingPage.vue?vue&type=script&setup=true&lang=js"

import "./PricingPage.vue?vue&type=style&index=0&id=4b3245fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b3245fe"]])

export default __exports__